import { InjectionToken } from '@angular/core';
import { IEnvironmentService } from './environment-service.interface';

export const ENVIRONMENT_SERVICE = new InjectionToken<IEnvironmentService>(
    'ENVIRONMENT_SERVICE'
);
